/** @format — Shared filter menu item with optional checkmark */

import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

export default function FilterMenuItem({
  active,
  onClick,
  children,
  className,
}: {
  active?: boolean;
  onClick: () => void;
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "flex w-full items-center gap-2 rounded-md px-2 py-[5.5px] text-left text-sm text-[#0a0a0a] transition-colors hover:bg-neutral-50",
        active && "bg-neutral-100",
        className,
      )}
    >
      <span className="min-w-0 flex-1">{children}</span>
      {active ? <Check className="h-4 w-4 shrink-0 text-[#737373]" strokeWidth={2} /> : null}
    </button>
  );
}

export function FilterMenuLabel({ children }: { children: React.ReactNode }) {
  return (
    <div className="px-2 py-[5.5px]">
      <p className="text-xs font-medium text-neutral-500">{children}</p>
    </div>
  );
}

export function FilterMenuDivider() {
  return (
    <div className="px-2 py-0.5">
      <div className="h-px bg-neutral-200" />
    </div>
  );
}
